import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getDropoffs = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/dropoffs?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearDropoff = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/dropoffs', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateDropoff = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/dropoffs/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteDropoff = (Id) => Axios.delete(`/dropoffs/${Id}`);